export const validateEmail = (value: string) => value.length > 0 && value.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/);

export const validatePhone = (value: string) => value.length > 0 && value.match(/^(\+?[\d\s]+)?(\d{3}|\(?\d+\))?(-?\s?\d)+$/);

export const validateVin = (value: string) => value.match(/^[\d\sA-Za-z-]+$/);
